import { gql } from '@apollo/client'

export const CALL_CUSTOMER_MUTATION = gql`
  mutation callCustomer($m2CaseId: ID, $processingId: ID, $attributes: CallCustomerInput!) {
    callCustomer(m2CaseId: $m2CaseId, processingId: $processingId, attributes: $attributes)
  }
`
